export default function (title) {
  useHead({
    titleTemplate: mainTitle => `${title} - ${mainTitle}`
  })
}
